import { render, staticRenderFns } from "./settlementAccount.vue?vue&type=template&id=7f1c3cf0&scoped=true&"
import script from "./settlementAccount.vue?vue&type=script&lang=js&"
export * from "./settlementAccount.vue?vue&type=script&lang=js&"
import style0 from "./settlementAccount.vue?vue&type=style&index=0&id=7f1c3cf0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1c3cf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7f1c3cf0', component.options)
    } else {
      api.reload('7f1c3cf0', component.options)
    }
    module.hot.accept("./settlementAccount.vue?vue&type=template&id=7f1c3cf0&scoped=true&", function () {
      api.rerender('7f1c3cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/settlementAccount.vue"
export default component.exports